import * as developmentConfig from './development.json';
import * as uatConfig from './uat.json';
import * as productionConfig from './production.json';

const appEnv = import.meta.env.VITE_APP_ENV || 'development';

const getConfig = () => {
  switch (appEnv) {
    case 'development':
      return developmentConfig;
    case 'uat':
      return uatConfig;
    case 'production':
      return productionConfig;
    default:
      return developmentConfig;
  }
};

export default getConfig();
